import React from 'react';
import { CalendarIcon, MapPinIcon, SparklesIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { SectionHeading } from './SectionHeading';
import type { StepIcon } from '../data/content';
const icons: Record<StepIcon, React.ComponentType<{
  className?: string;
}>> = {
  calendar: CalendarIcon,
  pin: MapPinIcon,
  sparkle: SparklesIcon
};
export function HowItWorks() {
  const {
    t
  } = useLanguage();
  return <section className="bg-navy py-20 sm:py-24" data-id="element-200" data-mp="lmcz668iljms">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-201" data-mp="qjml3bwp3d5v">
        <SectionHeading kicker={t.how.kicker} title={t.how.title} tone="dark" data-id="element-202" data-mp="ql7jjcm4rg90" />

        <ol className="relative mt-14 grid gap-10 lg:grid-cols-3 lg:gap-8" data-id="element-203" data-mp="cpvmuzoezfpg">
          <div className="absolute left-0 right-0 top-6 hidden h-px bg-white/15 lg:block" aria-hidden="true" data-id="element-204" data-mp="gs8opd01itgy" />
          {t.how.steps.map((step, index) => {
          const Icon = icons[step.icon];
          return <li key={step.title} className="relative" data-id="element-205" data-mp="2rleguet9vq4b" data-mpi={index}>
                <div className="flex items-center gap-4" data-id="element-206" data-mp="2rlxon2p7ky4m">
                  <span className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-brand-orange font-display text-lg font-extrabold text-white" data-id="element-207" data-mp="2mncqd8tiooit">
                    {index + 1}
                  </span>
                  <Icon className="h-5 w-5 text-brand-cyan" aria-hidden="true" data-id="element-208" data-mp="2wjfzwzqp7pfs" />
                </div>
                <h3 className="mt-6 font-display text-xl font-bold text-white" data-id="element-209" data-mp="3aachlvj36m82">{step.title}</h3>
                <p className="mt-2 max-w-sm text-sm leading-relaxed text-white/70" data-id="element-210" data-mp="36aaoiarf314e">
                  {step.description}
                </p>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}